export default RAILS_ASSET_URL("/wordmark-white.svg")
